import { useEffect, useState } from "react";
import {
  Outlet,
  useLoaderData,
  redirect,
  useRouteError,
  isRouteErrorResponse,

} from "@remix-run/react";
import MainLayout from "~/layouts/main-layout";
import { getSession } from "~/utils/session.server";

import { Button, Result, Spin } from "antd";

// 这个页面是做权限控制的
export const loader = async ({ request }: { request: Request }) => {
  const url = new URL(request.url);
  const session = await getSession(request.headers.get("Cookie"));
  const isAuthenticated = !!session.get("sessionId");

  // 根路径由 _index.tsx 处理，这里跳过
  if (url.pathname === "/") {
    return { isAuthenticated: true, userInfos: null };
  }

  // 如果未登录且不是访问登录页，重定向到登录页
  if (!isAuthenticated && !url.pathname.startsWith("/")) {
    return redirect(`/?redirectTo=${encodeURIComponent(url.pathname)}`);
  }

  // 如果已登录但访问的是登录页，重定向到首页
  // if (isAuthenticated && url.pathname.startsWith("/login")) {
  //   return redirect("/pages/workbench/pending");
  // }

  const userInfos = {
    userInfo: session.get("userInfo"),
    userRoles: session.get("userRoles") || [],
    sessionId: session.get("sessionId"),
  };

  // 允许的路由前缀
  const allowedPrefixes = ["/pages", "/admin", "/", "/api"];

  // 检查当前路径是否以允许的前缀开头
  const isAllowedRoute = allowedPrefixes.some((prefix) =>
    url.pathname.startsWith(prefix)
  );

  if (isAllowedRoute) {
    return { isAuthenticated: true, userInfos };
  }

  // ✅ 修复：对于不匹配的路由，返回 null 而不是什么都不返回
  return null;
};

export default function CatchAllRoute() {
  const data = useLoaderData<typeof loader>();
  const [isClient, setIsClient] = useState(false);

  // 如果loader返回了404响应，导航到404页面
  useEffect(() => {
    setIsClient(true);
    if (data instanceof Response && data.status === 404) {
      setTimeout(() => {
        window.location.href = "/pages/404";
      }, 50);
    }
  }, [data]);

  // 等待客户端渲染
  if (!isClient) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // 如果是正常的响应数据，渲染Outlet
  if (data && typeof data === "object" && "isAuthenticated" in data) {
    const { userInfos } = data;
    return (
      <MainLayout userInfos={userInfos}>
        <Outlet />
      </MainLayout>
    );
  }

  // 默认情况下显示加载状态或空内容
  return null;
}

export function CatchBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <div>
          <h1>404</h1>
          <p>Page not found</p>
        </div>
      );
    }
  }

  return (
    <div>
      <h1>404</h1>
      <p>Page not found</p>
    </div>
  );
}

// ✅ 修复 ErrorBoundary：确保 ErrorAddress 是有效的组件
export function ErrorBoundary() {
  // 最简单的错误边界，不使用 ErrorAddress
  return (
    <div style={{ padding: 20, textAlign: "center", marginTop: 50 }}>
      <button
        onClick={() => {
          window.location.href = "/pages/workbench/pending";
        }}
      >
        返回首页？？
      </button>
    </div>
  );
}
